import { dlclIdFieldMandatory } from './utilityFunctions';

export const salutationsMasters: string[] = ['Mr.', 'Ms.', 'M/S.', 'Mrs.'];
export const applicantStatusMasters: { [key: string]: string } = {
  Individual: 'Individual (Resident)',
  NRI: 'Individual (NRI)',
};
export const nationalitiesMasters: string[] = ['Indian', 'Others'];
export const occupationDetailsMasters: string[] = [
  'PVT.SECTOR SERVICE',
  'PUBLIC SECTOR',
  'GOVT.SERVICE',
  'HOUSEWIFE',
  'DEFENCE',
  'PROFESSIONAL',
  'RETIRED',
  'BUSINESS',
  'AGRICULTURE',
  'STUDENT',
  'FOREX DEALER',
  'OTHERS',
];

export const SourceOfFundMaster: { [key: string]: string } = {
  employment_salary: 'Employment / Salary',
  Business_consultancy_income: 'Business/Consultancy Income',
  dividend_interest: 'Dividend/Interest',
  donation_grant: 'Donation / Grant',
  pension_retirement_funds: 'Pension / Retirement Funds',
  shareholders_funds: 'Shareholders funds (for corporates)',
  reserves_retained_earnings: 'Reserves/Retained earnings (for corporates)',
  sales_of_assets: 'Sales of Assets / Property (other than securities)',
  sales_of_shares_securities_investment: 'Sale of Shares / Securities / Investment',
  gifts: 'Gift(s)',
  partners_members_funds: 'Partners/ Members funds (for partnership/other entities)',
  inheritance: 'Inheritance',
  others: 'Others',
};

export const grossAnnualMasters: string[] = [
  'BELOW 1 LAC',
  '1-5 LAC',
  '5-10 LACS',
  '10-25 LACS',
  '>25 LACS - 1 CRORE',
  '> 1 CRORE',
];

export const PEPsMasters = [
  { key: 'I am PEP', value: 'I am PEP' },
  { key: 'I am Related to PEP', value: 'I am Related to PEP' },
  { key: 'Not a PEP', value: 'Not Applicable' },
];

export const addressTypesMasters: string[] = [
  'Resident/Business',
  'Resident',
  'Business',
  'Registered Office',
  'Unspecified',
];

export const whetherRegisterMaster: { [key: string]: string } = {
  nbfc: 'NBFC',
  pension_fund: 'Pension Fund',
  insurance_compant: 'Insurance Company',
  provident_fund: 'Provident Fund',
  sebi_intermediary: 'SEBI Registered Intermediary',
  none_of_above: 'None of the Above',
};

export const genderMasters: string[] = ['Male', 'Female', 'Others'];

export const IdentityProofsMasters: string[] = [
  'Photo PAN Card',
  'Passport',
  "Voter's ID",
  'Driving License',
  'Aadhar Card',
];

export const AddressProofsMasters: string[] = [
  'Passport',
  "Voter's ID",
  'Ration Card',
  'Electricity Bill',
  'Landline/Telephone Bill',
  'Gas Bill',
  'Latest Bank Statement/Passbook',
  'Latest Depository Account Statement',
];

export const BankAccountProofsMasters: string[] = [
  'Bank Statement with IFSC printed on it',
  'Cancelled cheque leaf verified',
  'Letter from the bank giving account details',
  'Passbook (showing bank account details)',
];

export const DrawDownMasters: number[] = [1, 2, 3, 4];

export const filterApplicationTypes = [
  { key: 'individual', value: 'Individual (Resident)' },
  { key: 'non_individual', value: 'Non-Individual' },
  { key: 'poa', value: 'Individual (POA)' },
  { key: 'nri', value: 'Individual (NRI)' },
  { key: 'nri_poa', value: 'Individual (NRI-POA)' },
];

export const ModeOfHoldingTypes = [
  { key: 'single', value: 'Single' },
  { key: 'either or survivor,joint', value: 'Joint' },
];

export const IMAGE_UPLOAD_FORMATS = ['image/jpeg', 'application/pdf', 'image/png', 'image/jpg'];

export const INVESTOR_IMAGE_UPLOAD_FORMATS = ['image/png', 'image/jpg', 'image/jpeg'];

export const APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};

export const SUPPORT_STATUS: { [key: string]: string } = {
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_fundmanager: 'Approved by investment manager',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};

export const POA_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_reviewer: 'Sent to Kfin Reviewer',
  sent_to_amc_approver: 'Sent to Approver 1',
  sent_to_amc_approver2: 'Sent to Approver 2',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const ESIGN_STATUS: { [key: string]: string } = {
  NOT_GENERATED: 'notgenerated',
  PENDING_SIGNATURE: 'pendingsignature',
  SIGNED: 'signed',
  EXPIRED: 'expired',
};

export enum USER_ROLES {
  SUPER_ADMIN = 'superadmin',
  AMC_ADMIN = 'amcadmin',
  RM = 'rm',
  DISTRIBUTOR = 'distributor',
  INVESTOR = 'investor',
  FUND_MANAGER = 'fundmanager',
  TRUSTEE = 'trustee',
  WITNESS = 'witness',
  APPLICATION = 'application',
  SUBDISTRIBUTOR = 'subdistributor',
  POAAPPROVER = 'poaapprover',
  KFIN_REVIEWER = 'reviewer',
  AMCAPPROVER = 'amcapprover',
  AUTHORISEDSIGNATORY = 'authorisedsignatory',
}

export const ApplicationStatusBasedOnRole: {
  [key: string]: { [key: string]: string | { [key: string]: string } };
} = {
  [USER_ROLES.POAAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_poa_approver: 'Pending',
  },
  [USER_ROLES.AMCAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_amc_approver: {
      approver1: 'Pending',
    },
    sent_to_amc_approver2: {
      approver2: 'Pending',
    },
  },
  [USER_ROLES.KFIN_REVIEWER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_reviewer: 'Pending',
  },
};

export const Relations = ['Mother', 'Father', 'Daughter', 'Son', 'Spouse'];

export const NomineeRelations = [
  'MOTHER',
  'FATHER',
  'DAUGHTER',
  'SON',
  'SPOUSE',
  'BROTHER',
  'SISTER',
  'OTHERS',
];

export const adminSupportMaster: { [key: string]: string } = {
  unlock_user: 'Unlock User',
  check_whitelisted: 'Check Whitelisted',
  whitelist_user: 'Whitelist User',
  unwhitelist_user: 'Unwhitelist User',
  change_expired_status: 'Change Expired Status',
  change_status_to_draft: 'Change Status to draft',
};

export const AML_ALL_DISPLAY_MODE = false; // true = show all matches, false = show first match only

export const IS_DOB_APPLICABLE_FOR_AMC = true;

export const REJECTED_ROLES: { [key: string]: string } = {
  poaapprover: 'POA Approver',
  amcapprover: 'AIF Approver',
};

export const investorTypeMasters: { [key: string]: string } = {
  trust: 'Trust',
  corporate: 'Company',
  partnership_firm: 'Partnership Firm (Including LLPs)',
  huf: 'HUF',
  bank: 'Bank',
  // govt_bodies: 'Army/ Government Bodies',
  // registered_society: 'Registered Society',
  // fii_fpi: 'FII/FPI',
  // institutional_investor: 'Institutional Investor',
  // unincorporated_or_body_of_individuals: 'Unincorporated association or a body of individuals',
  // foreign_entity: 'Foreign Entity',
};
export const IS_PENNYDROP_APPLICABLE_FOR_AMC = true;

export const getGroupNameMaster = ['Group-A', 'Group-B', 'Group-C'];

export const NON_INDIVIDUAL_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_reviewer: 'Sent to Kfin Reviewer',
  sent_to_amc_approver: 'Sent to Approver 1',
  sent_to_amc_approver2: 'Sent to Approver 2',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const CpUboCodesMaster: { [key: string]: string } = {
  C01: '- CP of legal person-ownership',
  C02: '- CP of legal person-other means',
  C03: '- CP of legal person-senior managing official',
  C04: '- CP of legal arrangement-trust-settlor',
  C05: '- CP of legal arrangement-trust-trustee',
  C06: '- CP of legal arrangement-trust-protector',
  C07: '- CP of legal arrangement-trust-beneficiary',
  C08: '- CP of legal arrangement-trust-other',
  C09: '- CP of legal arrangement-trust-other-settlor-equivalent',
  C10: '- CP of legal arrangement-trust-other-trustee-equivalent',
  C11: '- CP of legal arrangement-trust-other-protector-equivalent',
  C12: '- CP of legal arrangement-trust-other-beneficiary-equivalent',
  C13: '- CP of legal arrangement-trust-other-other-equivalent',
  C14: '- Unknown',
};
// CP/UBO codes that may legitimately have 0% beneficial interest (the "Yes"
// rows of the CP code table). Codes C01 (ownership), C07 (beneficiary),
// C12 (beneficiary-equivalent) are "Generally No"
export const zeroBeneficialInterestAllowedCpCodes: string[] = [
  'C02',
  'C03',
  'C04',
  'C05',
  'C06',
  'C08',
  'C09',
  'C10',
  'C11',
  'C13',
  'C14',
];
export const controllingPersonsNationalitiesMasters: string[] = ['Indian', 'Others'];

//Application types
export enum APPLICATION_TYPE {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
}

export const AMC_APPROVER_CHECK_FOR_INDIVIDUAL = true; // this parameter is used to check application should be sent to approver first before investor

export const ENABLE_EMAIL_OTP = true;

export const APPLICATION_STATUS_AMCAPPROVER_individual: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_reviewer: 'Sent to Kfin Reviewer',
  sent_to_amc_approver: 'Sent to Approver 1',
  sent_to_amc_approver2: 'Sent to Approver 2',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};
export const IndividualApplicationStatusBasedOnRole: {
  [key: string]: { [key: string]: string | { [key: string]: string } };
} = {
  [USER_ROLES.AMCAPPROVER]: {
    ...APPLICATION_STATUS_AMCAPPROVER_individual,
    sent_to_amc_approver: {
      approver1: 'Pending',
    },
    sent_to_amc_approver2: {
      approver2: 'Pending',
    },
  },
  [USER_ROLES.KFIN_REVIEWER]: {
    ...APPLICATION_STATUS_AMCAPPROVER_individual,
    sent_to_reviewer: 'Pending',
  },
};

export const APPLICATION_LISTING_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_reviewer: 'Sent to Kfin Reviewer',
  sent_to_amc_approver: 'Sent to Approver 1',
  sent_to_amc_approver2: 'Sent to Approver 2',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};
export enum APPLICATION_TYPE_FOR_DOCUMENTS {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
  INDIVIDUAL_POA = 'individual_poa',
  NRI = 'nri',
  NRI_POA = 'nri_poa',
  NOMINEE_DOC = 'nominee',
  NOMINEE_GUARDIAN = 'nomineeGuardian',
}
export const BankAccountTypeMaster: { [key: string]: string } = {
  Current: 'CURRENT',
  Savings: 'SAVING',
};
export const NRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
};
export const DistributorTypesForUserManageMent: { [key: string]: string } = {
  Individual: 'individual',
  Company: 'company',
};

export const ENABLE_KRA_DOCUMENT_FETCH = true;

export const SALT = 'F2lNZWFxUH';
export const SALT2 = 'WTVPJel6dTGVocF';

export const RISK_SALT = 'Zp3$k9Q!tA7@xL2#Fv8';
export const RISK_SALT2 = 'Gm4^R8w*Qn1!cT6$Dz5';

export const ONBOARDING_OPTIONS: { [key: string]: string } = {
  otp: 'OTP',
  email_consent: 'Email Consent',
};

export const EmailConsentStatusMaster: { [key: string]: string } = {
  pending: 'Pending',
  rejected: 'Rejected',
  approved: 'Approved',
  revoked: 'Revoked',
};

export const ENABLE_Email_Consent = false;

export const TYPEOFEXCEPTION: { [key: string]: string } = {
  criminal_matter: 'Criminal matter',
  civil_matter: 'Civil matter',
  sebi_matter: 'SEBI matter',
  mca_matter: 'MCA matter',
  court_order: 'Court order',
  money_laundering: 'Money Laundering',
  rbi_matter: 'RBI matter',
  other_regulatory_matters: 'other Regulatory matters',
  other: 'Others',
};

export const dlclIdFieldValidationDate = '2024-05-01'; //Applicable date FOR  validating dlclId fields in kyc details and contributor details for individual and non-individual respectively
export const projectIsProd = true;

export const DLCLMasters: { [key: string]: string } = {
  cdsl: 'CDSL',
  nsdl: 'NSDL',
  // ...(dlclIdFieldMandatory() ? {} : { none: 'None' }),
};

export const DOCUMENT_ALLOW_PASTE = false;

export const dematFieldValidationDate = '2024-05-01'; //Applicable date for validating demat fields as per regex in KYC details

export const dpIdFieldValidationDate = '2025-12-05'; //Applicable date for validating dpId fields in kyc details and contributor details for individual and non-individual respectively

export const additionalKycFieldsMap: { [key: string]: string } = {
  occupationDetails: 'Occupation Details',
  occupationType: 'Occupation Type',
  grossAnnualIncome: 'Gross Annual Income',
  politicallyExposedPersonStatus: 'Politically Exposed Person Status',
  ckycNo: 'CKYC No',
  netWorth: 'Net Worth',
  sourceOfFunds: 'Source Of Funds',
  netWorthDate: 'Net Worth Date',
  fundSource: 'Find Source',
  sourceOfFundsLegitimacy: 'Source Of Funds Legitimacy',
  sourceOfFundsDeclaration: 'Source Of Funds Declaration',
  dlclId: 'Demat Details',
  dpId: 'DP ID',
  clId: 'CL ID',
  nameOfBroker: 'Name of Broker',
};

export const addressFieldsMap: { [key: string]: string } = {
  address1: 'Address Line 1',
  address2: 'Address Line 2',
  city: 'City',
  state: 'State',
  country: 'Country',
  pincode: 'Pincode',
  address_type: 'Address Type',
};

export const addressTypeMap: { [key: string]: string } = {
  'Correspondence Address': 'Correspondence Address',
  'Permanent Address': 'Permanent Address',
  'Overseas Address': 'Overseas Address',
};

export const contactFieldsMap: { [key: string]: string } = {
  phoneNumberoffice: 'Phone Number (Office)',
  phoneNumberResidence: 'Phone Number (Residence)',
  email: 'Email',
  mobile: 'Mobile',
  countryNameAndCode: 'Country Name and Code',
  countryCode: 'Country Code',
  kraMobileNumber: 'KRA Mobile Number',
  alternateEmail: 'Alternate Email',
  alternateMobile: 'Alternate Mobile',
};

export const bankFieldsMap: { [key: string]: string } = {
  ifscCode: 'IFSC Code',
  bankAccountNumber: 'Bank Account Number',
  bankAccountType: 'Bank Account Type',
  bankName: 'Bank Name',
  bankBranch: 'Bank Branch',
  defaultBankAccount: 'Default Bank Account',
  isActive: 'Is Active',
  pennydropCheck: 'Penny Drop Check',
  pennydropVerified: 'Penny Drop Verified',
  address1: 'Address Line 1',
  address2: 'Address Line 2',
  address3: 'Address Line 3',
  micrCode: 'MICR Code',
  bankAddress: 'Bank Address',
};

export const contributorFieldsMap: { [key: string]: string } = {
  name: 'Name',
  namePrefix: 'Name Prefix',
  motherName: `Mother's Name`,
  fatherOrSpouseName: 'Father/Spouse Name',
  ckycVerified: 'CKYC Verified',
  kraVerified: 'KRA Verified',
  dateOfBirth: 'Date of Birth',
  status: 'Status',
  nationality: 'Nationality',
  panNo: 'PAN Number',
  detailsOfFamilyCompany: 'Details of Family/Company',
  relationShipWithFirstApplicant: 'Relationship with First Applicant',
  mobile: 'Mobile',
};

export const distributorFieldsMap: { [key: string]: string } = {
  distributor_id: 'Distributor ID',
  distributorName: 'Distributor Name',
  loginType: 'Login Type',
  empCode: 'Employee Code',
  email: 'Email',
  firstName: 'First Name',
  subdistributorId: 'Sub-distributor ID',
  subdistributorName: 'Sub-distributor Name',
  subdistributorEmail: 'Sub-distributor Email',
  filledBy: 'Filled By',
  distributorEmail: 'Distributor Email',
  distributorPhone: 'Distributor Phone',
  distributorAlternatePhoneNumber: 'Distributor Alternate Phone Number',
  subdistributorPhone: 'Sub-distributor Phone',
  subdistributorAlternatePhoneNumber: 'Sub-distributor Alternate Phone Number',
};

export const nomineeFieldsMap: { [key: string]: string } = {
  nomineeName: 'Nominee Name',
  nomineeRelationship: 'Nominee Relationship',
  dateOfBirth: 'Date of Birth',
  nomineePercentage: 'Nominee Percentage',
  guardianName: 'Guardian Name',
  isActive: 'Is Active',
  Relationship: 'Relationship',
  nominationDocumentCheck: 'Nomination Document Check',
  nomineePan: 'Nominee PAN',
  nomineeGuardianPan: 'Nominee Guardian PAN',
  doNotWishToNominate: 'I do not wish to nominate',
};

export const fatcaFieldsMap: { [key: string]: string } = {
  gender: 'Gender',
  typeOfAddressProvidedAtKRA: 'Type of Address Provided at KRA',
  taxResidentOfAnyCountryOtherThanIndia: 'Tax Resident of Any Country Other Than India',
  placeOfBirth: 'Place of Birth',
  countryOfBirth: 'Country of Birth',
  countryOfNationality: 'Country of Nationality',
  taxCountryName: 'Tax Country Name',
  taxID: 'Tax ID',
  idType: 'ID Type',
  nameOfEntity: 'Name of Entity',
  dateOfIncorporation: 'Date of Incorporation',
  cityOfIncorporation: 'City of Incorporation',
  countryOfIncorporation: 'Country of Incorporation',
  entityExcemptionCode: 'Entity Exemption Code',
  usPerson: 'U.S. Person',
  usCitizenCheck: 'U.S. Citizen Check',
  fundTaxOfferCheck: 'Fund Tax Offer Check',
  informationDeclaration: 'Information Declaration',
  fundIntimateDeclaration: 'Fund Intimate Declaration',
  fundRegulatorsDeclaration: 'Fund Regulators Declaration',
  fatcaCrsDocumentCheck: 'FATCA/CRS Document Check',
};

export const groupSignatoriesFieldsMap: { [key: string]: string } = {
  groupId: 'Group ID',
  name: 'Name',
  pan: 'PAN',
  mobile: 'Mobile',
  countryNameAndCode: 'Country Name and Code',
  countryCode: 'Country Code',
  email: 'Email',
  designation: 'Designation',
  canEsign: 'Can eSign',
  isActive: 'Is Active',
};

export const contactPersonFieldsMap: { [key: string]: string } = {
  name: 'Name',
  landLineNumber: 'Landline Number',
  email: 'Email',
  mobile: 'Mobile',
  alternateEmail: 'Alternate Email',
  alternateMobile: 'Alternate Mobile',
  stdCode: 'STD Code',
  countryNameAndCode: 'Country Name and Code',
  countryCode: 'Country Code',
};

export const nonIndividualContributorFieldsMap: { [key: string]: string } = {
  name: 'Name',
  cityOfIncorporation: 'City of Incorporation',
  ckycNo: 'CKYC No',
  ckycVerified: 'CKYC Verified',
  kraVerified: 'KRA Verified',
  investorType: 'Investor Type',
  detailsOfFamilyCompany: 'Details of Family/Company',
  registeredAs: 'Registered As',
  registrationNumber: 'Registration Number',
  netWorthDate: 'Net Worth Date',
  dateOfBirth: 'Date of Birth',
  panNo: 'PAN Number',
  grossAnnualIncome: 'Gross Annual Income',
  netWorth: 'Net Worth',
  politicallyExposedPersonStatus: 'Politically Exposed Person Status',
  dlclId: 'Demat Details',
  dpId: 'DP ID',
  clId: 'CL ID',
  nameOfBroker: 'Name of Broker',
};

export const uboFieldsMap: { [key: string]: string } = {
  panNumber: 'PAN Number',
  dob: 'Date of Birth',
  name: 'Name',
  identificationType: 'Identification Type',
  percentageOfBeneficialInterest: 'Percentage of Beneficial Interest',
  beneficialInterestReason: 'Reason for Beneficial Interest',
  countryOfTaxResidency: 'Country of Tax Residency',
  cpUboCode: 'CP UBO Code',
  placeAndCountryOfBirth: 'Place and Country of Birth',
  occupation: 'Occupation',
  gender: 'Gender',
  nationality: 'Nationality',
  fatherName: "Father's Name",
  ckycNumber: 'CKYC Number',
  address1: 'Address Line 1',
  address2: 'Address Line 2',
  address3: 'Address Line 3',
  city: 'City',
  state: 'State',
  country: 'Country',
  pincode: 'Pincode',
  isActive: 'Is Active',
  isFetchData: 'Is Fetch Data',
  amlCheck: 'AML Check',
  amlComments: 'AML Comments',
  amlAcknowledgement: 'AML Acknowledgement',
  ubo_declaration_type: 'UBO Declaration Question',
  ubo_declaration_value: 'UBO Declaration Answer',
  ubo_declaration_others_value: 'UBO Declaration Answer',
};

export const controllingPersonFieldsMap: { [key: string]: string } = {
  fatcaDetailId: 'FATCA Detail ID',
  name: 'Name',
  correspondenceAddress: 'Correspondence Address',
  countryOfResidense: 'Country of Residence',
  tin: 'TIN',
  issuingCountry: 'Issuing Country',
  controllingPersonType: 'Controlling Person Type',
  indentificationType: 'Identification Type',
  indentificationNumber: 'Identification Number',
  occupationType: 'Occupation Type',
  occupation: 'Occupation',
  dateOfBirth: 'Date of Birth',
  countryOfBirth: 'Country of Birth',
  nationality: 'Nationality',
  isActive: 'Is Active',
};

export const documentTypeNameMap: { [key: string]: string } = {
  identityProof: 'ID Proof',
  addressProof: 'Address Proof',
  bankAccountProof: 'Bank Account Proof (Upload Default Bank Account Proof)',
  investorSignature: 'Specimen Signature',
  investorPhotograph: 'Investor Photograph',
  screeningReport: 'Screening Report',
  compliance_document: 'Compliance Document',
  sourceOfFund: 'Document for Source of Funds',
  demat_information: 'Proof of Demat Account',
  poaNotarized: 'POA Notarized Document',
  investorsConsent: 'Investors Consent Document',
  fatca: 'Fatca Document',
  additional: 'Additional Documents',
  photograph_of_investor: 'Photograph of the Investor',
  signature_of_investor: 'Specimen Signature of the Investor',
  photo_of_poa: 'Photo of POA holder',
  id_of_poa: 'PAN Card or ID proof of POA holder',
  address_of_poa: 'Address proof of POA holder',
  authority_letter:
    'Authority letter/document in favor of authorised signatory of the POA holder (In case the POA holder is a non-individual entity)',
  pan_of_authorised:
    'PAN Card or ID proof of Authorised Signatory of POA holder (In case the POA holder is a non-individual entity)',
  address_of_authorised:
    'Address proof of Authorised Signatory of POA holder (In case POA holder is a non-individual entity)',
  taxResidency: 'Tax Residency Certificate',
  visa: 'Valid Visa Copy',
  passport: 'Passport Copy',
  id_proof_nominee: 'ID Proof of Nominee',
  address_proof_nominee: 'Address Proof of Nominee',
  dob_proof_nominee: 'Date of Birth Proof of Nominee',
  photograph_of_nominee: 'Photograph of Nominee',
  id_proof_guardian: 'ID Proof of Guardian (if nominee is minor)',
  address_proof_guardian: 'Address Proof of Guardian (if nominee is minor)',
  dob_proof_guardian: 'Date of Birth Proof of Guardian (if nominee is minor)',
  photograph_of_guardian: 'Photograph of Guardian (if nominee is minor)',
  certificate_of_incorporation: 'Certificate of Incorporation',
  memorandum_articles: 'Memorandum and Articles of Association',
  board_resolution: 'Copy of the Board Resolution for investment in securities market.',
  list_of_directors: 'List of Directors',
  list_of_authorised_signatories: 'List of Authorised Signatories',
  id_proof_authorised_signatories: 'ID Proof of Authorised Signatories',
  address_proof_authorised_signatories: 'Address Proof of Authorised Signatories',
  pan_of_corporate: 'PAN Card of Corporate',
  address_proof_corporate: 'Address Proof of Corporate',
  authorised_signatories_signatures: 'Authorized signatories list with specimen signatures',
  annual_report_2yrs: 'Copy of the Constitution Document / MOA-AOA',
  fatca_ubo:
    'Declaration of UBO in case of multi-layer structure where an individual person is indirectly controlling the entity',
  address_proof_of_entity: 'Address Proof of the Entity',
  pan_card_entity: 'Copy of PAN Card of the Entity',
  copyOfBoardResolution:
    'Copy of the Board Resolution / Authority Document for investment in AIF and for authorized signatories to sign all the agreements and necessary documents',
  copy_of_registration: 'Copy of Registration Certificate',
  copy_of_annual_report: 'Copy of Annual report/Balance Sheet for the last 2 financial years',
  photoOfDirectors:
    'Photo of whole-time directors/two directors in charge of day-to-day operations',
  panOfDirectors:
    'Copy of PAN Card of whole-time directors/two directors in charge of day-to-day operations',
  copy_of_address_proof_director:
    'Copy of Address proof of whole-time directors/two directors in charge of day-to-day operations',
  photo_of_promoters:
    'Photo of individual promoters/other individual person holding control - either directly or indirectly',
  pan_of_promotor:
    'Copy of PAN Card of individual promoters/another individual person holding control - either directly or indirectly',
  copy_of_address_proof_promoters:
    'Copy of Address proof of individual promoters/other individual person holding control - either directly or indirectly',
  id_proof_of_authorised: 'PAN Card/ID Proof of the Authorised Signatory Signing the Application',
  proof_constitution_doc: 'Proof of Existence/Constitution document.',
  POA_resolution:
    'Resolution of the managing body or Power of Attorney or Authority Document to Invest in the Fund.',
  panCardOfSeniorManaging:
    'PAN Card of whole-time members/ senior managing officials in charge of operations of the Entity',
  address_proof_of_senior_managing:
    'Address proof of whole-time members/ senior managing officials in charge of operations of the Entity',
  certificate_of_registration: 'Certificate of registration',
  confirmation_mail: 'Confirmation Mail from K Fin',
  aif_approval_mail: 'Approval Mail from AIF Approver 1',
  MD_approval_mail: 'Approval Mail from MD',
  change_request_form: 'Change Request Form',
};

export const RiskCategoryMap: { [key: string]: string } = {
  riskCategory: 'Risk Category',
  riskCategoryExplanation: 'Risk Category Explanation',
};

export const NCT_STATUS: { [key: string]: string } = {
  pending: 'Pending',
  completed: 'Completed',
};

export const NCT_APPLICATION_STATUS: {
  [status: string]: string | { [role: string]: string };
} = {
  draft: 'Draft',
  completed: 'Completed',
  rejected: 'Rejected',
  sent_to_amc_approver2: {
    [USER_ROLES.AMCAPPROVER]: 'Pending',
    default: 'Sent to Approver 2',
  },
};

export const RISK_CATEGORIZATION: { [key: string]: string } = {
  high_risk: 'High Risk',
  low_risk: 'Low Risk',
  medium_risk: 'Medium Risk',
};
export const YesNoBooleanMaster: { [key: string]: string } = {
  true: 'Yes',
  false: 'No',
};

export const YesNoMaster: { [key: string]: string } = {
  yes: 'Yes',
  no: 'No',
};

export const TRUNCATE_TEXT_LENGTH = 10;

export const allFieldMaps: Record<string, string>[] = [
  additionalKycFieldsMap,
  addressFieldsMap,
  addressTypeMap,
  contactFieldsMap,
  bankFieldsMap,
  contributorFieldsMap,
  distributorFieldsMap,
  nomineeFieldsMap,
  fatcaFieldsMap,
  groupSignatoriesFieldsMap,
  contactPersonFieldsMap,
  nonIndividualContributorFieldsMap,
  uboFieldsMap,
  controllingPersonFieldsMap,
  documentTypeNameMap,
  RiskCategoryMap,
];

export const brokerNameValidationStartDate = '2025-12-05';

export const COMMENT_ROLES: { [key: string]: string } = {
  rm: 'RM',
  distributor: 'Distributor',
  subdistributor: 'Sub Distributor',
  amcapprover: 'AIF Approver',
  poaapprover: 'POA Approver',
};

export const AIF_ROLE_TYPE: { [key: string]: string } = {
  approver1: 'Approver 1',
  approver2: 'Approver 2',
};

export const YES_NO_MASTER: { [key: string]: string } = {
  yes: 'Yes',
  no: 'No',
};

export const YES_NO_BOOLEAN_MASTER: { [key: string]: string } = {
  true: 'Yes',
  false: 'No',
};
